import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Settings from "./Settings";
import "./App.css";

const predefinedSequence = [
  "tails", "tails", "heads", "tails", "heads", "tails", "heads", "heads", "heads", "tails",
]; // flips

const Home = () => {
  const [flipping, setFlipping] = useState(false);
  const [isHeads, setIsHeads] = useState(predefinedSequence[0]); // Always start at first flip
  const [flipIndex, setFlipIndex] = useState(0); // Reset on refresh

  const flipCoin = () => {
    if (flipping) return;

    setFlipping(true);

    setTimeout(() => {
      const nextFlip = predefinedSequence[flipIndex];
      setIsHeads(nextFlip === "heads");

      // Move to the next flip, reset to 0 after 20 flips
      setFlipIndex((prevIndex) => (prevIndex + 1) % predefinedSequence.length);
    }, 750); // Change side at halfway point

    setTimeout(() => {
      setFlipping(false);
    }, 3000);
  };

  return (
    <div className="container">
      <h1>WELCOME TO TOIN COSS</h1>
      <h2>HEADS OR TAILS</h2>

      <div className={`coin ${flipping ? "flipping" : ""} ${isHeads ? "heads" : "tails"}`}>
        <div className="coin-face front">
          <img src={process.env.PUBLIC_URL + "/heads.png"} alt="heads" />
        </div>
        <div className="coin-face back">
          <img src={process.env.PUBLIC_URL + "/tails.png"} alt="tails" />
        </div>
      </div>
      <button onClick={flipCoin} disabled={flipping}>
        {flipping ? "Flipping..." : "Flip Coin"}
      </button>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <div className="settingsOne">
      <nav>
  <Link to="/" className="nav-link">Home</Link> | <Link to="/settings" className="nav-link">Settings</Link>
</nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
